// import { Link } from "react-router-dom";

// material-ui
import { Grid, Stack, Typography } from "@mui/material";

// project import
import AuthLogin from "./auth-forms/AuthLogin";
import logo from "../../assets/images/KrishL_logo.jpg";

// ================================|| LOGIN ||================================ //

const Login = () => (
  <Grid
    container
    justifyContent={"center"}
    maxWidth={500}
    className="m-auto mt-5"
  >
    <Grid container justifyContent="center">
      <img src={logo} height={182} alt="" />
    </Grid>
    <Grid item xs={10} className="mt-3 mb-3">
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        sx={{ mb: { xs: -0.5, sm: 0.5 } }}
      >
        <Typography
          variant="h6"
          className="d-flex justify-content-between align-items-center fw-bolder"
        >
          <Grid item xs={12} className="">
           Please login with your phone number
          </Grid>{" "}
          {/* <Grid item xs={5}>
            <img src={logo} height={100} alt="" />
          </Grid>{" "} */}
        </Typography>
        {/* <Typography
          component={Link}
          to="/register"
          variant="body1"
          sx={{ textDecoration: "none" }}
          color="primary"
        >
          Don&apos;t have an account?
        </Typography> */}
      </Stack>
    </Grid>
    <Grid item xs={10}>
      <AuthLogin />
    </Grid>
  </Grid>
);

export default Login;
